import { LogUnfinishedMetadata } from '@/types/logs'

import DangerFlagIcon from '../../../assets/danger-flag.svg'
import FlagIcon from '../../../assets/flag.svg'
import styles from './FlagStateIcon.module.scss'

interface Props {
    metadata: LogUnfinishedMetadata | null | undefined
}

export const FlagStateIcon = ({ metadata }: Props) => {
    if (metadata?.flag && metadata.flagState === 'Done') {
        return (
            <span className={styles.blue}>
                <FlagIcon />
            </span>
        )
    }

    if (metadata?.flag) {
        return (
            <span className={styles.red}>
                <DangerFlagIcon />
            </span>
        )
    }

    return (
        <span className={styles.grey}>
            <FlagIcon />
        </span>
    )
}
